module.exports = __webpack_public_path__ + "img/savings-circle.b27bf6c7.svg";